import { render, staticRenderFns } from "./SmartLodgingView.vue?vue&type=template&id=47bbcb47"
import script from "./SmartLodgingView.vue?vue&type=script&lang=js"
export * from "./SmartLodgingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports